import env from '@frontend/env';
import { ErrorBoundary } from '@frontend/error-boundary';
import { IpcShellProvider } from '@frontend/shell-utils';
import { requestUserPreferencesSync } from '@frontend/user-preferences';
import { ThemeProvider } from '@frontend/design-system';
import { App } from './app';
import { DebugModeProvider } from './providers/debug-provider';
import { NotificationManagerProvider } from './providers/notification-manager';

requestUserPreferencesSync();

const Root = () => {
  console.log('Version: - ', env.VERSION);
  return (
    <ErrorBoundary
      tier='app'
      feature='notification.root'
      team='frontend-ops'
      fallback={() => {
        window.location.reload();
        return <>An Error Occurred</>;
      }}
    >
      <IpcShellProvider context='notifications'>
        <ThemeProvider includeEmotionTheme skipAnimation={false}>
          <DebugModeProvider>
            <NotificationManagerProvider>
              <App />
            </NotificationManagerProvider>
          </DebugModeProvider>
        </ThemeProvider>
      </IpcShellProvider>
    </ErrorBoundary>
  );
};

export default Root;
